import { useState } from "react";
import { MODULE_API } from "../../../../apis";
import useModuleData from "./useFetchItems";

export default function useCreateAttributeWithSubType(
  moduleName,
  formData,
  setFormData,
  setToUpdate,
  fetchDataWithSubType,
  formatModuleKey,
  setTableData,
  setLoading
) {
  const [error, setError] = useState(false);

  const createAttributeWithSubType = async (subType) => {
    try {
      setLoading(true);
      const response = await MODULE_API.addAssetWithSubType(moduleName, {
        clientModules: [{ ...formData }], 
      }, subType); 
      
      // Fetch data with the same subType to refresh the table
      const res = await fetchDataWithSubType(moduleName, subType);
      
      setTableData((prev) => ({
        ...prev,
        [formatModuleKey(moduleName)]: res && res.records || [],
      }));
      
      setLoading(false);
      setFormData(null);
      setToUpdate(false); // Reset update flag since we're creating new
    } catch (error) {
      console.error("Error creating attribute with subType:", error);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  return { createAttributeWithSubType, error };
}
